// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import LogKey from "./log-key.js"
import LogSubject from "./log-subject.js"
import User from "./user.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "parameters": {
      "column": {
        "default": null,
        "name": "parameters",
        "null": true,
        "type": "jsonb"
      },
      "name": "parameters",
      "selected_by_default": null,
      "translated": null
    },
    "trackable_id": {
      "column": {
        "default": null,
        "name": "trackable_id",
        "null": true,
        "type": "uuid"
      },
      "name": "trackable_id",
      "selected_by_default": null,
      "translated": null
    },
    "trackable_type": {
      "column": {
        "default": null,
        "name": "trackable_type",
        "null": true,
        "type": "string"
      },
      "name": "trackable_type",
      "selected_by_default": null,
      "translated": null
    },
    "receipient": {
      "column": null,
      "name": "receipient",
      "selected_by_default": false,
      "translated": null
    },
    "trackable": {
      "column": null,
      "name": "trackable",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "Log",
  "collectionKey": "logs",
  "collectionName": "logs",
  "i18nKey": "log",
  "camelizedLower": "log",
  "name": "Log",
  "nameDasherized": "log",
  "pluralName": "logs",
  "ransackable_associations": [
    {
      "className": "LogKey",
      "collectionName": "log_keys",
      "foreignKey": "log_key_id",
      "name": "log_key",
      "macro": "belongs_to",
      "resource_name": "LogKey",
      "through": null
    },
    {
      "className": "LogSubject",
      "collectionName": "log_subjects",
      "foreignKey": "log_subject_id",
      "name": "log_subject",
      "macro": "belongs_to",
      "resource_name": "LogSubject",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "Trackable",
      "collectionName": null,
      "foreignKey": "trackable_id",
      "name": "trackable",
      "macro": "belongs_to",
      "resource_name": null,
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "user_id",
      "name": "user",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "log_key_id",
      "column": {
        "default": null,
        "name": "log_key_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "log_subject_id",
      "column": {
        "default": null,
        "name": "log_subject_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_log_key_id",
      "column": {
        "default": null,
        "name": "old_log_key_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_log_subject_id",
      "column": {
        "default": null,
        "name": "old_log_subject_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_recipient_id",
      "column": {
        "default": null,
        "name": "old_recipient_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_trackable_id",
      "column": {
        "default": null,
        "name": "old_trackable_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_user_id",
      "column": {
        "default": null,
        "name": "old_user_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "parameters",
      "column": {
        "default": null,
        "name": "parameters",
        "null": true,
        "type": "jsonb"
      }
    },
    {
      "name": "parameters_deprecated",
      "column": {
        "default": null,
        "name": "parameters_deprecated",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "recipient_id",
      "column": {
        "default": null,
        "name": "recipient_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "recipient_type",
      "column": {
        "default": null,
        "name": "recipient_type",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "trackable_id",
      "column": {
        "default": null,
        "name": "trackable_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "trackable_type",
      "column": {
        "default": null,
        "name": "trackable_type",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "user_id",
      "column": {
        "default": null,
        "name": "user_id",
        "null": true,
        "type": "uuid"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "invoice_or_invoice_line_invoice_id"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "LogKey",
      "collectionName": "log_keys",
      "foreignKey": "log_key_id",
      "name": "log_key",
      "macro": "belongs_to",
      "resource_name": "LogKey",
      "through": null
    },
    {
      "className": "LogSubject",
      "collectionName": "log_subjects",
      "foreignKey": "log_subject_id",
      "name": "log_subject",
      "macro": "belongs_to",
      "resource_name": "LogSubject",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "user_id",
      "name": "user",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    }
  ],
  "paramKey": "log",
  "primaryKey": "id"
}

/** Frontend model for Log. */
export default class Log extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {Record<string, any> | Array<any> | null} */
  parameters() {
    return this.readAttributeUnderscore("parameters")
  }

  /** @returns {boolean} */
  hasParameters() {
    const value = this.parameters()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  trackableId() {
    return this.readAttributeUnderscore("trackable_id")
  }

  /** @returns {boolean} */
  hasTrackableId() {
    const value = this.trackableId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  trackableType() {
    return this.readAttributeUnderscore("trackable_type")
  }

  /** @returns {boolean} */
  hasTrackableType() {
    const value = this.trackableType()

    return this._isPresent(value)
  }

  /** @returns {any} */
  receipient() {
    return this.readAttributeUnderscore("receipient")
  }

  /** @returns {boolean} */
  hasReceipient() {
    const value = this.receipient()

    return this._isPresent(value)
  }

  /** @returns {any} */
  trackable() {
    return this.readAttributeUnderscore("trackable")
  }

  /** @returns {boolean} */
  hasTrackable() {
    const value = this.trackable()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static keys(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "keys",
        collectionName: "logs",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static pageView(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "page_view",
        collectionName: "logs",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static translatedTrackableTypes(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "translated_trackable_types",
        collectionName: "logs",
        type: "collection"
      },
      commandArgs
    ))
  }

  /** @returns {import("./log-key.js").default | null} */
  logKey() {
    return this._readBelongsToReflection({modelClass: LogKey, reflectionName: "log_key"})
  }

  /** @returns {Promise<import("./log-key.js").default | null>} */
  loadLogKey() {
    if (!("logKeyId" in this)) throw new Error("Foreign key method wasn't defined: logKeyId")

    const id = this.logKeyId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "log_key",
        model: this,
        modelClass: LogKey
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./log-key.js").default | null>} */
  ensureLogKeyLoaded() {
    return this.ensureAssociationLoaded("log_key")
  }

  /** @returns {import("./log-subject.js").default | null} */
  logSubject() {
    return this._readBelongsToReflection({modelClass: LogSubject, reflectionName: "log_subject"})
  }

  /** @returns {Promise<import("./log-subject.js").default | null>} */
  loadLogSubject() {
    if (!("logSubjectId" in this)) throw new Error("Foreign key method wasn't defined: logSubjectId")

    const id = this.logSubjectId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "log_subject",
        model: this,
        modelClass: LogSubject
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./log-subject.js").default | null>} */
  ensureLogSubjectLoaded() {
    return this.ensureAssociationLoaded("log_subject")
  }

  /** @returns {import("./user.js").default | null} */
  user() {
    return this._readBelongsToReflection({modelClass: User, reflectionName: "user"})
  }

  /** @returns {Promise<import("./user.js").default | null>} */
  loadUser() {
    if (!("userId" in this)) throw new Error("Foreign key method wasn't defined: userId")

    const id = this.userId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "user",
        model: this,
        modelClass: User
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./user.js").default | null>} */
  ensureUserLoaded() {
    return this.ensureAssociationLoaded("user")
  }
}
